(() => {
  const script = document.currentScript;
  const label = script?.dataset.contentsLabel;
  const content = document.querySelector('.shopify-policy__body') || document.querySelector('#MainContent rte-formatter');
  if (!content || !label || content.querySelector('.yvicor-policy-nav')) return;
  const headings = [...content.querySelectorAll('h2')].filter((heading) => heading.textContent.trim());
  if (headings.length < 5) return;
  const details = document.createElement('details');
  details.className = 'yvicor-policy-nav';
  const summary = document.createElement('summary');
  summary.textContent = label;
  const nav = document.createElement('nav');
  nav.setAttribute('aria-label', label);
  const list = document.createElement('ul');
  headings.forEach((heading, index) => {
    if (!heading.id) {
      let id = 'policy-section-' + (index + 1);
      while (document.getElementById(id)) id += '-section';
      heading.id = id;
    }
    heading.classList.add('yvicor-policy-anchor');
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
  });
  nav.append(list);
  details.append(summary, nav);
  content.prepend(details);
})();
